document.addEventListener('DOMContentLoaded', function () {
  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    const checkBtnInterval = setInterval(() => {
      const btns = document.querySelectorAll('[name="checkout"]');
      btns.forEach(btn => {
        clearInterval(checkBtnInterval);
        const newBtn = btn.cloneNode(true);
        newBtn.setAttribute("type", "button");
        btn.parentNode.replaceChild(newBtn, btn);

        // new event
        newBtn.addEventListener("click", function(e) {
          e.preventDefault();
          console.log("Checkout clicked");
          BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
        });
      });
    }, 500);
  }
});